
<template>
  <div class="goods-page" v-loading="loading">
    <!-- 赠品 -->
    <div v-if="sampleType === 'GIFT_MATERIAL'" class="goods-list-box" ref="goodsListBox">
      <div class="details-img">
        <h3 class="details-title">{{ detailsInfo.title }}</h3>
        <el-image
          style="width: 200px; height: 200px;"
          :src="detailsInfo.mainImage + $ImgQuality30"
          :preview-src-list="[detailsInfo.mainImage + $ImgPreviewQuality]"
          fit="contain"
        >
          <div slot="placeholder" class="sample-image-slot">
            加载中
          </div>
        </el-image>
        <!-- 赠品附件 -->
        <div class="material-file gift-file">
          <h4 style="float: left;">文件: </h4>
          <p
            v-for="(item, index) in sampleVO.sampleAttachmentVOs"
            :key="index"
          >
            <el-popover
              placement="top-start"
              trigger="hover"
              popper-class="popper--upload-class"
              :disabled="popoverDisabled"
            >
              <div>
                <el-button type="text" icon="el-icon-view" @click="previewBtn(item)">预览</el-button>
                <el-button type="text" icon="el-icon-download" @click="downloadFile(item)">下载</el-button>
              </div>
              <p slot="reference">
                <i class="el-icon-document"></i>
                {{ item.name }}
              </p>
            </el-popover>
          </p>
        </div>
      </div>
    </div>
    <!-- 原料、包材、odm 、膜布-->
    <div v-else class="goods-list-box" ref="goodsListBox">
      <div v-if="sampleType !== 'RAW_MATERIAL'" class="details-img">
        <el-carousel
          v-if="carouselImages && carouselImages.length > 1"
          height="200px"
          style="width: 200px"
          arrow="always"
          indicator-position="none"
          :interval="0"
        >
          <el-carousel-item v-for="(item,index) in carouselImages" :key="item" style="width: 100%;height: 100%">
            <el-image
              style="width: 200px; height: 200px;"
              :src="item"
              @click="carouselImageChange(index)"
              fit="fill"
            >
              <div slot="placeholder" class="sample-image-slot">加载中</div>
            </el-image>
          </el-carousel-item>
        </el-carousel>
        <el-image
          v-else
          style="width: 200px; height: 200px;"
          :src="detailsInfo.mainImage + $ImgQuality30"
          :preview-src-list="[detailsInfo.mainImage + $ImgPreviewQuality]"
          fit="contain"
        >
          <div slot="placeholder" class="sample-image-slot">
            加载中
          </div>
        </el-image>
        <!-- 膜布——显示附件 -->
        <div v-if="sampleType === 'MEMBRANE_CLOTH'" class="material-file">
          <h4 style="float: left;">文件: </h4>
          <p
            v-for="(item, index) in sampleVO.sampleAttachmentVOs"
            :key="index"
          >
            <el-popover
              placement="top-start"
              trigger="hover"
              popper-class="popper--upload-class"
              :disabled="popoverDisabled"
            >
              <div>
                <el-button type="text" icon="el-icon-view" @click="previewBtn(item)">预览</el-button>
                <el-button type="text" icon="el-icon-download" @click="downloadFile(item)">下载</el-button>
              </div>
              <p slot="reference">
                <i class="el-icon-document"></i>
                {{ item.name }}
              </p>
            </el-popover>
          </p>
        </div>
      </div>
      <!-- 原料 -->
      <div v-else class="details-material">
        <h3 class="details-title">{{ detailsInfo.title }}</h3>
        <h4>文件:</h4>
        <P
          v-for="(item, index) in detailsInfo.fileList"
          :key="index"
          >
          <el-popover
            placement="top-start"
            trigger="hover"
            popper-class="popper--upload-class"
            :disabled="popoverDisabled"
          >
            <div>
              <el-button type="text" icon="el-icon-view" @click="previewBtn(item)">预览</el-button>
              <el-button type="text" icon="el-icon-download" @click="downloadFile(item)">下载</el-button>
            </div>
            <p slot="reference">
              <i class="el-icon-document"></i>
              {{ item.name }}
            </p>
          </el-popover>
        </P>
      </div>
      <!-- 包材、odm -->
      <div class="details-box">
        <h3 v-if="sampleType !== 'RAW_MATERIAL'" class="details-title">
          {{ detailsInfo.title }}
        </h3>
        <h3 v-else style="margin-top: 30px"></h3>
        <div class="details-ml">
          <b v-if="sampleType === 'PACKING_MATERIAL' && detailsInfo.list && detailsInfo.list[0].capacity">{{ detailsInfo.capacityName }}：</b>
          <b v-else-if="sampleType === 'PACKING_MATERIAL' && detailsInfo.list && !detailsInfo.list[0].capacity">数量（个）：</b>
          <b v-else>{{ detailsInfo.capacityName }}：</b>
          <div>
            <div
              v-for="(item, index) in detailsInfo.list"
              :key="index"
              class="details-ml-input"
            >
              <span v-if="sampleType === 'PACKING_MATERIAL' && detailsInfo.list[0].capacity">{{ item.capacity }}{{ detailsInfo.capacityUnit }}</span>
              <el-input-number
                v-model="item.num"
                :min="0"
                :precision="0"
                :step="1"
                :max="sampleVODetail.find(item => item.type === VO).max"
              />
            </div>
          </div>
        </div>
        <div class="details-btns">
          <el-button
            v-if="sampleType !== 'GIFT_MATERIAL'"
            size="mini"
            type="primary"
            :loading="shopCartLoading"
            v-hasPermission="'warehouse-sample-manage/sample-application-add-cart'"
            @click="setSampleToCart('to-cart')"
            >加入购物车</el-button
          >
          <el-button
            v-if="sampleType !== 'GIFT_MATERIAL'"
            size="mini"
            type="primary"
            :loading="sampleLoading"
            v-hasPermission="'warehouse-sample-manage/sample-application-apply'"
            @click="setSampleToCart('get-sample')"
            >立即索样</el-button
          >
          <p v-if="btnTips" class="btn-tips">
            <i class="el-icon-warning-outline"></i>
            {{ btnTips }}
          </p>
        </div>
      </div>
    </div>

    <h3>详细信息</h3>
    <div class="goods-details-box">
      <div class="goods-details-cont" v-for="(item, index) in data" :key="index">
        <div v-if="!item.hide">
          <span>{{ item.label }}：</span>
          <div v-if="item.type === 'array-more'" class="details-array">
            <span v-for="(el, index) in item.value" :key="index">
              <span>{{ el[item.propArray[0]] }}{{ el.unit }}</span>
              <span style="margin: 0 5px"
                >({{ el[item.propArray[1]] }}元)；</span
              >
            </span>
          </div>
          <p v-else-if="item.type === 'array'">{{ item.value }}</p>
          <p v-else style="word-break: break-all;">{{ item.value }}<b v-if="item.prop === 'supplierName' && isPotentialSupplier" style="color: #f00;">(正在引入评估中的供应商)</b></p>
        </div>
      </div>
      <div class="preview-box" >
        <div class="preview-text" v-if="previewImgList.length > 0">
          <el-image 
            :src="require('../../../assets/images/preview.png')" 
            :preview-src-list="previewImgList">
          </el-image>
        </div>
        <div :class="[information ? 'information' : 'information2', `id-${row.id}`]" v-html="information"></div>
      </div>
    </div>
    <!-- 索样 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="90%"
      custom-class="goods-dialog"
      top="8vh"
      @close="dialogClose"
    >
      <ApplySample v-if="dialogVisible" ref="ApplySample" @on-success="smapleSaveSuccess" @submit-error="dialogVisible=false" />
    </el-dialog>

    <!-- 预览文件 -->
    <previewFileDialog :type="fileType" :url="fileUrl" ref="previewDialog" />
    <!-- 加入购物车浮框 -->
    <div v-show="sampleType !== 'GIFT_MATERIAL'" class="fixed-box">
      <el-popover placement="top" v-model="shoppingVisible" trigger="hover">
        <div class="details-box" style="max-width: 250px">
          <h4 v-if="sampleType !== 'RAW_MATERIAL'" class="details-title-fixed">
            {{ detailsInfo.title }}
          </h4>
          <h4 v-else style="margin-top: 30px"></h4>
          <div class="details-ml-fixed">
            <b v-if="sampleType === 'PACKING_MATERIAL' && detailsInfo.list && detailsInfo.list[0].capacity">{{ detailsInfo.capacityName }}：</b>
            <b v-else-if="sampleType === 'PACKING_MATERIAL' && detailsInfo.list && !detailsInfo.list[0].capacity">数量  （个）：</b>
            <b v-else>{{ detailsInfo.capacityName }}：</b>
            <div>
              <div v-for="(item, index) in detailsInfo.list" :key="index" class="details-ml-input">
                <span v-if="sampleType === 'PACKING_MATERIAL' && detailsInfo.list[0].capacity">{{   item.capacity }}{{ detailsInfo.capacityUnit }}</span>
                <el-input-number
                  v-model="item.num"
                  :min="0"
                  :precision="0"
                  :step="1"
                  :max="sampleVODetail.find(item => item.type === VO).max"
                />
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: right; margin: 0">
          <el-button type="text" @click="shoppingVisible = false">取消</el-button>
          <el-button :loading="shopCartLoading" type="primary" @click="setSampleToCart('to-cart')">确定</el-button>
        </div>
        <el-button v-show="isScroll" slot="reference" size="medium" type="primary" v-hasPermission="'warehouse-sample-manage/sample-application-add-cart'" icon="el-icon-shopping-cart-1" circle />
      </el-popover>
    </div>
    <!-- 轮播图预览 -->
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="dialogImageVisible"
      :initial-index="initialIndex > -1 ? initialIndex : 0"
      :on-close="()=> {this.dialogImageVisible = false}"
      :url-list="carouselImages"
    />
  </div>
</template>
<script>
import sampleDetailsMixin from '@/mixins/sampleDetailsMixin';
import { filterPage, sampleVODetail } from '@/utils/pageInfo';
import ApplySample from '@/components/ApplySample';
import previewFileDialog from '@/components/previewFileDialog';
import download from '@/utils/download';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'Goods',
  mixins: [sampleDetailsMixin],
  components: { ApplySample, previewFileDialog, ElImageViewer },
  props: {},
  data() {
    return {
      previewImgList: [],
      loading: false,
      num: 1,
      max: 5,
      detailsInfo: {},
      data: [],
      shopCartLoading: false,
      sampleLoading: false,
      row: {
        id: '',
        productId: '',
        specificationId: '',
      },
      sampleType: '',
      VO: '',
      sampleVO: {},
      information: '',
      dialogVisible: false,
      fileType: '',
      fileUrl: '',
      popoverDisabled: false,
      isPotentialSupplier: false,
      shoppingVisible: false,
      isScroll:false,
      shoppingVisibleBtn: false,
      carouselImages: [],
      dialogImageVisible: false,
      initialIndex: 0
    };
  },
  computed: {
    btnTips() {
      return this.sampleVODetail.find(item => item.type === this.VO)
        ? this.sampleVODetail.find(item => item.type === this.VO).btnTips
        : '';
    },
    sampleVODetail() {
      return sampleVODetail
    },
  },
  watch: {
    '$route': {
      handler(item) {
        if (item.name === 'details-page/goods') {
          if(item.query.id) {
            const { id, productId, specificationId, type } = item.query;
            this.row.id = id;
            this.row.productId = productId;
            this.row.specificationId = specificationId;
            this.sampleType = this.sampleVODetail.find(
              el => el.name === type,
            ).sampleType;
            this.getDetail();
            setTimeout(() => {
              this.previewImgList = Array.prototype.map.call(document.querySelectorAll(`.id-${this.row.id} img`), (a) => a.src)
            }, 500)
          }
        }
      },
      immediate: true,
    }
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll,true);
  },
  methods: {
    handleScroll() {
      const scroll = document.getElementsByClassName('el-main')[0].scrollTop
      const offsetHeight = this.$refs.goodsListBox.offsetHeight
      this.isScroll =  scroll > offsetHeight ? true: false
    },
    getDetail() {
      this.loading = true;
      this.$http.sampleManage[
        this.sampleVODetail.find(item => item.sampleType === this.sampleType).url
      ](this.row.productId)
        .then(result => {
          this.getSupplierByCode(result.data.supplierCode);
          const VO = filterPage(this.sampleType).listDataParam;
          this.VO = VO;
          this.sampleVO = result.data;
          
          // mixin
          this.$nextTick(() => {
            this.information = result.data.information;
            this[`get${VO}`](VO, this.sampleVO, result);
            this.formValueChange(this.sampleVO);
          });

        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 添加所选商品到vuex保存
    setSampleToCart(val) {
      const selectData = this.detailsInfo.list
        .filter(item => item.num > 0)
        .map(el => {
          return {
            ...this.sampleVO,
            ...el,
          };
        });
      if (selectData.length < 1) {
        this.$message.error('样品数量必须为大于0的整数');
        return;
      }
      if (val === 'to-cart') {
        // 添加购物车
        const params = selectData.map(item => {
          return {
            num: item.num,
            sampleId: this.row.id,
            sampleType: this.sampleType,
            specificationId: item.specificationId,
          };
        });
        this.addShopCartFunc(params);
      } else {
        this.$http.sample.orderCanCreate().then(res => {
          if (res.data && res.data === true) {
            // 去索样
            const sampleData = [
              {
                supplierName: selectData[0].supplierName,
                isFormal: this.isPotentialSupplier ? '1' : '0',
                list: selectData.map(item => {
                  item.productId = item.id;
                  item.sampleType = this.sampleType;
                  return item;
                }),
              },
            ];
            this.$store.commit('addSampleToCart/addSampleData', sampleData);
            this.dialogVisible = true;
            this.$nextTick(() => {
              this.$refs.ApplySample.setListForm(sampleData);
            });
          } else {
            this.$message.error('存在超过30天未反馈的样品申请，请先完成样品反馈再发起寻样申请');
          }
        }).catch((err) => {
          this.$message.error(err.msg);
        })
      }
    },
    // 提交索样申请
    smapleSaveSuccess() {
      this.dialogVisible = false;
      this.goSampleQuery();
    },
    goSampleQuery() {
      const name = '我的寻样';
      const paramName = 'warehouse-sample-manage/sample-mylist';
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        close: {
          name: this.$route.meta.title,
          href: this.$route.path,
        },
        open: {
          name: name,
          href: `/${paramName}`,
        },
      });
      this.$router.push({
        name: paramName,
      });
    },
    // 下载模板文件
    downloadFile({ url, name }) {
      download(url, name);
    },
    // 预览文件
    previewBtn({name, url}) {
      // 隐藏popover弹窗
      this.popoverDisabled = true;
      setTimeout(() => {
        this.popoverDisabled = false;
      }, 500);
      const fileExtend = name.substring(name.lastIndexOf('.')).toLowerCase();
      this.fileUrl = url;
      this.fileType = fileExtend.indexOf('pdf') > -1 ? 'pdf' : 'file';
      this.$refs.previewDialog.dialogVisible = true;
    },
    dialogClose() {
      this.$refs.ApplySample.clearProductInfoForm();
    },
    getSupplierByCode(code) {
      this.$http.setting
        .getByCode(code)
        .then(result => {
          this.isPotentialSupplier = result.data.isFormal && result.data.isFormal === '1';
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    // 轮播图片预览
    carouselImageChange(index) {
      this.dialogImageVisible = true
      this.initialIndex = index
    }
  },
};
</script>
<style lang="less" scoped>
.goods-page {
  max-width: 1000px;
  margin: 0 auto;
}
.goods-list-box {
  display: flex;
  padding-bottom: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #ccc;
}
.details-img {
  margin-right: 50px;
  img {
    width: 250px;
    height: 250px;
  }
}
.details-btns {
  margin: 10px 0 0 -30px;
  button {
    margin: 10px 30px;
  }
}
.details-box {
  .details-title-fixed {
    display: -webkit-box;
    word-break: break-all;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .details-title {
    margin-bottom: 20px;
  }
  .details-ml {
    min-height: 155px;
  }
  .details-ml,.details-ml-fixed {
    display: flex;
    overflow: auto;
    b {
      font-weight: normal;
    }
    span {
      margin: 0 5px;
    }
    .details-ml-input {
      margin-bottom: 10px;
      text-align: right;
      span {
        display: inline-block;
        margin-right: 15px;
        max-width: 80px;
      }
    }
  }
}
h3 {
  margin-bottom: 10px;
}
.goods-details-box {
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
  .goods-details-cont {
    width: 48%;
    margin: 5px 2% 5px 0;
    font-size: 14px;
    color: #999;
    span {
      float: left;
    }
    p {
      line-height: 20px;
      word-break: break-all;
    }
  }
  .details-array span {
    display: flex;
    align-items: center;
  }
}
.btn-tips {
  font-size: 12px;
  color: #AB0033;
  padding-left: 30px;
}

/deep/ .preview-box{
  width: 100%;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ccc;
  .preview-text{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    .el-image{
      vertical-align: top;
      margin-left: 5px;
      min-width: 25px !important;
      width: 25px !important;
      height: 25px !important;
    }
  }
  .information {
    margin-top: 20px;
    img {
      width: 30%;
      height: 30%;
      vertical-align: top;
    }
    word-break: break-all;
  }
}
/deep/ .information2 {
  border: none
}
.details-material {
  width: 280px;
  margin-right: 10px;
  max-height: 240px;
  overflow: auto;
  line-height: 20px;
  h4 {
    float: left;
    margin: 0 10px 10px 0;
    font-weight: normal;
  }
  p {
    margin: 5px 0 5px 10px;
    font-size: 14px;
    color: #AB0033;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
.gift-file {
  width: auto!important;
}
.material-file {
  margin: 10px 0;
  width: 300px;
  max-height: 210px;
  overflow: auto;
  h4 {
    font-weight: 400;
  }
  p {
    color: #AB0033;
    cursor: pointer;
    display: block;
    line-height: 20px;
    padding-left: 50px;
    min-width: 200px;
    &:first-child {
      float: left;
      margin-left: -50px;
      margin-right: 10px;
    }
  }
  .el-popover__reference {
    color: #AB0033;
  }
}
.goods-dialog {
  .product-info-box {
    max-height: 650px;
  }
}
.cml-content-box {
  height: auto;
}
.fixed-box {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 30px;
  .el-button {
    font-size: 26px;
  }
}
</style>
<style lang="less">
.popper--upload-class {
  margin-bottom: 0px !important;
}
</style>
